import React from 'react'
import { useParams } from 'react-router'
import { components } from 'cng-web-lib'

import FormProperties from './FormPage'
import TmpSysConfigApiUrls from 'src/apiUrls/tmp-admin/TmpSysConfigApiUrls'

const { form: { CngEditForm } } = components

function EditPage({ history, showNotification}) {
    
    const { id } = useParams()

    return (
        <CngEditForm
            fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
            history={history}
            showNotification={showNotification}
            bodySection={
                <FormProperties.Fields
                    showNotification={showNotification}
                    id={id}
                />
            }
            formikProps={FormProperties.formikProps}
            toClientDataFormat={FormProperties.toClientDataFormat}
            toServerDataFormat={FormProperties.toServerDataFormat}
            fetch={{ url: TmpSysConfigApiUrls.GET }}
            update={{ url: TmpSysConfigApiUrls.EDIT }}
            id={id}
        />
    )
}

export default EditPage